import { Component, OnInit } from '@angular/core';
import { MainService } from '../../services/main.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-tender',
  templateUrl: './tender.component.html',
  styleUrls: ['./tender.component.css']
})
export class TenderComponent implements OnInit {

  constructor(private ms: MainService,private route: ActivatedRoute,
      private router: Router,) { }

  isLoaded:boolean = false;

  tenderSlug:any;

  tenderContent:any;

  menu:any;

  ngOnInit() {
  	this.loadMenu();

    this.tenderSlug = this.route.snapshot.paramMap.get('tslug');
    this.ms.getTenderContent(this.tenderSlug).subscribe((r:any)=>{
      this.tenderContent = r;
    })



    this.route.params.subscribe( params => {
      this.tenderSlug = params.pid;
      this.isLoaded=false;
      this.ms.scrollToTop(500);
      this.ms.getTenderContent(this.tenderSlug).subscribe((r:any)=>{
        this.tenderContent = r;
      })
    });



  }

  loadMenu(){
  	this.ms.scrollToTop(500);
  	this.ms.getTender().subscribe((r)=>{
  		this.isLoaded = true;
  		this.menu = r;
  	})	
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tender/tender.component.ts